<button *ngIf="toastPackage.config.closeButton"
        class="toast-close-button float-right"
        aria-label="Close"
        (click)="remove()">
    <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="toastPackage.title"
     class="toast-title">
    {{ toastPackage.title }}
</div>
<div *ngIf="toastPackage.message"
     class="toast-message">
    {{ toastPackage.message }}
</div>
<div *ngIf="toastPackage.config.payload.buttonText"
     class="d-flex justify-content-center mt-2">
    <button class="btn btn-sm btn-white"
            (click)="onBtnClick($event)">
        {{ toastPackage.config.payload.buttonText }}
    </button>
</div>

